// extracted by mini-css-extract-plugin
export default {"description":"CheckBoxWithLabel_description__aEwiI"};